import { Button, Skeleton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetRulesQuery } from 'api/ml-service/ml-service';
import CustomRule from './custom-rule/custom-rule.component';
import { useUtilityDrawer } from 'components/drawers/utility-drawer/utility-drawer.hooks';
import AddCustomRuleDrawer from 'components/drawers/add-custom-rule-drawer/add-custom-rule-drawer.component';
import { getRules } from 'api/ml-service/fixtures/ml-service.fixtures';
import IncPageSectionTitle from 'components/inc-page-section-title/inc-page-section-title.component';

const CustomRules = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetRulesQuery(null);
  const { open, setOpen, close } = useUtilityDrawer();

  return (
    <Stack gap={2} mt={2}>
      <Button onClick={() => setOpen(true)} sx={{ alignSelf: 'flex-start' }}>
        {t('page.menus.recommendations.customRules.createButton.label')}
      </Button>

      <IncPageSectionTitle
        title={t(
          'page.menus.recommendations.customRules.savedCustomRules.title',
        )}
      />

      {isFetching
        ? [0, 1, 2].map(index => (
            <Skeleton variant="rounded" key={index} width="100%">
              <CustomRule rule={getRules.rules[0]} />
            </Skeleton>
          ))
        : data?.rules.map(rule => {
            return <CustomRule rule={rule} key={rule.ruleId} />;
          })}

      <AddCustomRuleDrawer open={open} close={close} />
    </Stack>
  );
};

export default CustomRules;
